import Cookies from 'js-cookie';

import {
  CSRF_COOKIE_KEY,
  FORCED_LOGOUT_STORAGE_KEY,
  FORCED_LOGOUT_VERSION,
  USER_INFO_COOKIE_KEY,
} from '@/constants';
import { logout } from '@/data/services/authService';

const CLIENT_READABLE_AUTH_COOKIES = [CSRF_COOKIE_KEY, USER_INFO_COOKIE_KEY];

const LOGIN_ROUTE = '/login';

function getCookieScopes(hostname: string): (string | undefined)[] {
  const labels = hostname.split('.');
  const parentDomains = labels.map(
    (_, index) => `.${labels.slice(index).join('.')}`,
  );
  return [undefined, ...parentDomains];
}

export function removeClientReadableAuthCookies(): void {
  const scopes = getCookieScopes(window.location.hostname);

  CLIENT_READABLE_AUTH_COOKIES.forEach(key =>
    scopes.forEach(domain =>
      Cookies.remove(key, domain ? { domain } : undefined),
    ),
  );
}

export function forceLogoutOnce(): void {
  if (localStorage.getItem(FORCED_LOGOUT_STORAGE_KEY) === FORCED_LOGOUT_VERSION)
    return;

  localStorage.setItem(FORCED_LOGOUT_STORAGE_KEY, FORCED_LOGOUT_VERSION);
  removeClientReadableAuthCookies();

  const isLoginRoute = window.location.pathname.startsWith(LOGIN_ROUTE);

  logout()
    .catch(() => undefined)
    .finally(() => {
      if (!isLoginRoute) window.location.replace(LOGIN_ROUTE);
    });
}
